import styled from 'styled-components'

const Box = styled.div`
  width: 720px;
  height: 600px;

  position: absolute;
  top: 24px;

  display: flex;
  flex-direction: column;

  border-radius: ${(props) => props.theme.uiKit.borderRadius.roundedModal};
  background-color: ${(props) => props.theme.uiKit.colors.global.general.main};

  & > * {
    width: 100%;
  }
`

export const s = { Box }
